export const isntantReqSteps = {
  searching: -3,
  failed: -2,
  found: -1,
  waiting: 1,
  // found: 0,
  notFound: 2,
};

const instantReqTypes = {
  SET_STEP: "SET_STEP",

  FETCH_STATUS_START: "FETCH_STATUS_START",
  FETCH_STATUS_SUCCESS: "FETCH_STATUS_SUCCESS",

  SET_STATUS_SHOWING: "SET_STATUS_SHOWING",

  RESPONSE_NEW_INSTANT_REQUEST_RESULT: "RESPONSE_NEW_INSTANT_REQUEST_RESULT",

  CLEAR_STATUS_SHOWING: "CLEAR_STATUS_SHOWING",
};
export default instantReqTypes;
